<template>
  <!-- <div id="this-customer"> -->
  <f7-page name="customer">
    <f7-navbar>
      <f7-nav-left>
        <f7-link
          icon-ios="f7:chevron_left"
          icon-md="material:chevron_left"
          href="/customerlist/"
          >Back</f7-link
        >
      </f7-nav-left>
      <f7-nav-title> Customer </f7-nav-title>
    </f7-navbar>

    <f7-card outline :title="customer.company_name" @taphold.native="testTap">
    </f7-card>
    <div class="upper-area">
      <f7-list accordion-list inset>
        <f7-list-item
          id="contacts"
          accordion-item
          title="Contacts"
          :badge="numbContacts"
          badge-color="blue"
        >
          <f7-accordion-content id="">
            <div>
              <table class="data-table">
                <thead class="bg-color-white">
                  <tr>
                    <th class="label-cell orient">
                      <span class="addContact"
                        ><a
                          :href="
                            '/addcontact/' + customer.id + '/model/fbcustomers'
                          "
                        >
                          +</a
                        ></span
                      >Name
                    </th>
                    <!-- <th class="label-cell orient">Last Name</th> -->
                    <th class="label-cell">Phone</th>
                    <!-- <th class="label-cell orient">Email</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="contact in customcontacts"
                    :key="contact.id"
                    class=""
                  >
                    <td class="label-cell">
                      {{ contact.first_name }} {{ contact.last_name }}
                    </td>
                    <!-- <td class="label-cell">{{ contact.last_name }}</td> -->
                    <td class="label-cell">
                      {{ contact.phone }}
                      <span
                        class="deleteContact"
                        @click="deleteContact(contact.id)"
                        >x</span
                      >
                    </td>
                    <!-- <td class="label-cell">{{ contact.email }}</td> -->
                  </tr>
                  <tr
                    v-for="contact in customercontacts"
                    :key="contact.id"
                    class=""
                  >
                    <td class="label-cell">
                      {{ contact.first_name }} {{ contact.last_name }}
                    </td>
                    <!-- <td class="label-cell">{{ contact.last_name }}</td> -->
                    <td class="label-cell">{{ contact.cell_phone }}</td>
                    <!-- <td class="label-cell">{{ contact.email }}</td> -->
                  </tr>
                </tbody>
              </table>
            </div>
          </f7-accordion-content>
        </f7-list-item>
        <f7-list-item
          id="sales"
          accordion-item
          title="Sales"
          :badge="ytd_sales"
          badge-color="blue"
        >
          <f7-accordion-content id="salesdata">
            <div>
              <table class="data-table">
                <thead class="bg-color-white">
                  <tr>
                    <th class="label-cell orient">Year</th>
                    <th class="label-cell">Total Revenue</th>
                    <th class="label-cell orient">Margin</th>
                    <th class="label-cell orient"># of Sales</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="sales in yearly_sales" :key="sales.id" class="">
                    <td class="">{{ sales.year }}</td>
                    <td class="label-cell">${{ sales.total }}</td>
                    <td class="label-cell">{{ sales.margin }}%</td>
                    <td class="label-cell">{{ sales.invoices }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </f7-accordion-content>
        </f7-list-item>
        <f7-list-item
          id="salescall"
          accordion-item
          title="Sales Calls"
          :badge="numb_calls"
          badge-color="green"
        >
          <f7-accordion-content id="calldata">
            <f7-list-item
              v-if="newSalesCall == true"
              :link="
                '/salescall/0/customerid/' + customer.id + '/model/fbcustomers'
              "
              title="New Sales Call"
            >
            </f7-list-item>
            <f7-list-item
              v-for="salescall in salescalls"
              :key="salescall.id"
              :link="
                '/salescall/' +
                salescall.id +
                '/customerid/' +
                customer.id +
                '/model/' +
                setModel(salescall) +
                '/referer/customer'
              "
            >
              {{ salescall.call_type }} by {{ salescall.user.full_name }} on
              {{ formatDate(salescall.created) }}
            </f7-list-item>
          </f7-accordion-content>
        </f7-list-item>
        <f7-list-item
          id="partscounter"
          accordion-item
          title="Parts Counter"
          badge-color="red"
        >
          <f7-accordion-content id="partscounter">
            <f7-link class="right" :href="'/partscounterrequestadd/' + id"
              ><i class="icon f7-icons color-blue">plus</i
              ><span class="prt">Part</span></f7-link
            >
            <PartsCounter
              :userid="user.id"
              :customerid="id"
              :customer="customer"
            />
          </f7-accordion-content>
        </f7-list-item>
        <f7-list-item
          id="note"
          accordion-item
          title="Notes"
          :badge="noteCount"
          badge-color="red"
        >
          <f7-accordion-content id="note">
            <Notes
              v-if="loadNotes == true"
              :model="model"
              :notes="customer.notes"
              :userid="user.id"
              :entid="customer.id"
              @notesCount="setNoteCount"
              @notesUpdate="noteRecord"
              @updateNotes="setNotes"
            />
          </f7-accordion-content>
        </f7-list-item>
        <f7-list-item
          accordion-item
          title="Pictures"
          :badge="picCount"
          badge-color="red"
        >
          <f7-accordion-content>
            <f7-swiper
              v-if="pics.length > 0"
              pagination
              navigation
              scrollbar
              :loop="false"
              :speed="500"
              :slidesPerView="1"
              :spaceBetween="20"
            >
              <f7-swiper-slide
                v-for="(pic, index) in pics"
                :key="index"
                :title="pic"
                @taphold.native="deletePic(pic)"
              >
                <figure>
                  <figcaption>{{ formatTitle(pic) }}</figcaption>
                  <img
                    class="tapHold"
                    :src="domain + picDir(pic) + pic"
                    @dblclick="deletePic(pic)"
                  />
                </figure>
              </f7-swiper-slide>
              <f7-swiper-slide
                ><div v-on:click="opencam">
                  <div>Add image...</div>
                  <i class="icon f7-icons color-blue slider_add">camera</i>
                </div></f7-swiper-slide
              >
            </f7-swiper>

            <f7-block v-else-if="pics.length == 0" class="upload_icon">
              <div v-on:click="opencam">
                <div>Add image...</div>
                <i class="icon f7-icons color-blue slider_add">camera</i>
              </div>
            </f7-block>
          </f7-accordion-content>
        </f7-list-item>
        <f7-list-item
          accordion-item
          title="Documents"
          :badge="docCount"
          badge-color="red"
        >
          <f7-accordion-content>
            <f7-swiper
              v-if="docs.length > 0"
              pagination
              navigation
              scrollbar
              :speed="500"
              :slidesPerView="3"
              :spaceBetween="20"
            >
              <f7-swiper-slide
                v-for="(doc, index) in docs"
                :key="index"
                @taphold.native="deleteDoc(doc)"
              >
                <div
                  class="tapHold"
                  style="padding: 10px"
                  @dblclick="deleteDoc(doc)"
                >
                  <iframe
                    type="application/pdf"
                    :src="domain + picDir(doc) + doc + '\#zoom=FitW'"
                  ></iframe>
                </div>
              </f7-swiper-slide>

              <f7-swiper-slide
                ><div v-on:click="upload_file">
                  <div>Add File...</div>
                  <i class="icon f7-icons color-blue slider_add"
                    >square_arrow_up</i
                  >
                </div></f7-swiper-slide
              >
            </f7-swiper>

            <f7-block v-else-if="docs.length == 0">
              <div v-on:click="upload_file" class="upload_icon">
                <div>Add File...</div>
                <i class="icon f7-icons color-blue slider_add"
                  >square_arrow_up</i
                >
              </div>
            </f7-block>
          </f7-accordion-content>
        </f7-list-item>
      </f7-list>
      <f7-popup id="camera" class="cam-popup">
        <!-- <f7-popup id="camera" class="cam-popup" :opened="popupOpened" @popup:closed="popupOpened = false"> -->
        <f7-page>
          <f7-navbar title="Upload Pictures">
            <f7-nav-right>
              <f7-link popup-close>Close</f7-link>
            </f7-nav-right>
          </f7-navbar>

          <Camera
            :model="model"
            :item="customer"
            :uid="user.id"
            @picList="setPics"
          />
          <!-- fbcustomer_133539_DFSASDF_1685132228 -->
        </f7-page>
      </f7-popup>
      <f7-popup id="fileloader" class="file-popup">
        <!-- <f7-popup id="fileloader" class="file-popup" :opened="popupOpened" @popup:closed="popupOpened = false"> -->
        <f7-page>
          <f7-navbar title="Upload Files">
            <f7-nav-right>
              <f7-link popup-close>Close</f7-link>
            </f7-nav-right>
          </f7-navbar>

          <FileLoader
            :model="model"
            :item="customer"
            :uid="user.id"
            @picList="setPics"
            @docList="setDocs"
          />
        </f7-page>
      </f7-popup>
    </div>

    <f7-toolbar bottom class="bottom-toolbar">
      <f7-link href="/"><i class="icon f7-icons color-blue">house</i></f7-link>

      <f7-link><i class="icon f7-icons color-blue">square_arrow_up</i></f7-link
      ><f7-link class="right" :href="'/partscounterrequestadd/' + id"
        ><i class="icon f7-icons color-blue">plus</i
        ><span class="prt">Part</span></f7-link
      >

      <f7-link
        ><i class="icon f7-icons color-blue">chat_bubble_text</i></f7-link
      >
      <f7-link><i class="icon f7-icons color-blue">camera</i></f7-link>
    </f7-toolbar>
  </f7-page>
  <!-- </div> -->
</template>

<script>
import Buttons from "../../components/Buttons.vue";
import Notes from "../../components/Notes.vue";
import Camera from "../../components/CameraComp.vue";
import FileLoader from "../../components/FileLoader.vue";
import PartsCounter from "../../components/Partscounter.vue";
import { dateTimeMixin } from "../../mixins/dateTimeMixin.js";
import { pictureMixin } from "../../mixins/pictureMixin.js";
import { runInThisContext } from "vm";
export default {
  mixins: [pictureMixin, dateTimeMixin],
  components: {
    Buttons,
    Notes,
    Camera,
    FileLoader,
    PartsCounter,
  },
  data() {
    return {
      componentKey: 0,
      id: "",
      token: "",
      customer: {},
      customercontacts: [],
      customcontacts: [],
      numbContacts: "",
      yearly_sales: "",
      ytd_sales: "",
      numb_calls: "",
      noteCount: "",
      docCount: "",
      notes: [],
      pics: [],
      docs: [],
      picCount: 0,
      salescalls: {},
      salescallCount: "",
      newSalesCall: true,
      model: "Fbcustomers",
      loadNotes: false,
      newContact: false,
      user: {
        first_name: "",
        last_name: "",
        id: 0,
        shop: "",
        token: "",
      },
      domain: "",
      fileUrl: "/webroot/files/Fbcustomers/doc/",
    };
  },
  mounted() {
    this.id = this.$f7route.params.id;
    this.loaded = true;
    this.userid = "4";
  },
  async created() {
    var user = this.$vlf.createInstance({
      storeName: "user",
    });
    await user
      .getItem("token")
      .then((value) => (this.token = value))
      .catch(function (err) {
        // This code runs if there were any errors
        console.log(err);
      });
    await user
      .getItem("id")
      .then((value) => (this.user.id = value))
      .catch(function (err) {
        // This code runs if there were any errors
        console.log(err);
      });
    const data = {
      id: this.$f7route.params.id,
    };
    this.domain = apiUrl;
    const url = apiUrl + "/api/fbcustomers/customerdetails";
    console.log(this.user);
    console.log(this.token);
    await axios
      .post(url, data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + TOKEN,
        },
      })
      .then((response) => {
        console.log(response);
        this.customer = response.data.customer;
        this.notes = response.data.customer.notes;
        this.salescalls = response.data.customer.salescalls;
        this.customercontacts = response.data.customer.customercontacts;
        this.customcontacts = response.data.customer.customcontacts;
        this.pics = response.data.pics;
        this.docs = response.data.docs;
        this.picCount = this.setBadge(response.data.pics.length);
        this.docCount = this.setBadge(response.data.docs.length);
        this.numbContacts = this.setBadge(
          response.data.customer.customcontacts.length +
            response.data.customer.customercontacts.length
        );
        this.loadNotes = true;
        console.log(this.notes);
        this.noteCount = this.setBadge(response.data.customer.notes.length);
        this.numb_calls = this.setBadge(
          response.data.customer.salescalls.length
        );
        console.log(this.salescalls);
        this.setNewSalesCall(this.salescalls[0].created);
      })
      // .then((response) => (this.vacations = response.data.items))
      .catch(function (error) {
        console.log(error);
      });

    const url2 = apiUrl + "/api/sales/yearlysales";
    const data2 = {
      formatted_name: this.customer.formatted_name,
    };

    await axios
      .post(url2, data2, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + TOKEN,
        },
      })
      .then((response) => {
        console.log(response);
        this.yearly_sales = response.data;
        this.ytd_sales =
          "YTD $" + response.data[response.data.length - 1].total;

        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
      });
    console.log(this.customer);
  },
  methods: {
    opencam() {
      const app = this.$f7;
      app.popup.open("#camera");
    },
    upload_file() {
      const app = this.$f7;
      app.popup.open("#fileloader");
    },
    setNoteCount(noteCount) {
      this.noteCount = this.setBadge(noteCount);
      this.notes = notes;
    },
    setSalescallCount(count) {
      console.log(count);

      this.SalescallCount = this.setBadge(count);
    },
    noteRecord(notesUpdate) {
      console.log("here");
      console.log(notesUpdate);
      this.salescall.notes = notesUpdate;
    },
    setDocs(docs) {
      this.docs = docs;
      this.docCount = this.setBadge(docs.length);
    },

    setBadge(num) {
      if (num > 0) {
        return num;
      } else {
        return "";
      }
    },
    testTap() {
      alert("yes");
    },
    setNewSalesCall(created) {
      var cur = new Date();
      var created = new Date(created);
      console.log(created);
      cur = this.$moment(cur).format("YYYY-MM-DD");
      created = this.$moment(created).format("YYYY-MM-DD");
      if (created == cur) {
        this.newSalesCall = false;
      }
      console.log(this.newSalesCall);
    },
    deletePic(pic) {
      var del = confirm("Delete this image?");

      if (del == true) {
        this.sendDeleteRequest(pic);
      }
    },
    deleteDoc(doc) {
      var del = confirm("Delete this document?");

      if (del == true) {
        this.sendDeleteRequest(doc);
      }
    },
    sendDeleteRequest(filename) {
      const data = {
        filename: filename,
      };
      console.log(data);
      const url = apiUrl + "/api/fbcustomers/deletedoc";

      axios
        .post(url, data, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + TOKEN,
          },
        })
        .then((response) => {
          console.log(response);
          this.pics = response.data.pics;
          this.picCount = this.setBadge(response.data.pics.length);
          this.docs = response.data.docs;
          this.docCount = this.setBadge(response.data.docs.length);
          // console.log(response)
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    addContact() {
      this.newContact = true;
    },
    setNotes(notes) {
      console.log(notes);
      this.customer.notes = notes;
    },
    picDir(pic) {
      pic = pic.split("_");
      if (pic[0] == "fbcustomer") {
        return "/webroot/files/Fbcustomers/doc/";
      } else if (pic[0] == "prospect") {
        return "/webroot/files/Prospects/doc/";
      }
    },
    setModel(salescall) {
      if (salescall.customerid != null) {
        return "fbcustomers";
      } else if (salescall.prospect_id != null) {
        return "prospects";
      }
    },

    deleteContact(id) {
      if (confirm("Are you sure you want to delete this contact?") == true) {
        const url = apiUrl + "/api/fbcustomers/deletecontact";
        const data = {
          id: id,
          customerid: this.$f7route.params.id,
        };
        axios
          .post(url, data, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "Bearer " + TOKEN,
            },
          })
          .then((response) => {
            console.log(response);
            this.customcontacts = response.data.customcontacts;
            this.numbContacts = this.setBadge(
              response.data.customcontacts.length + this.customercontacts.length
            );
          });
      }
    },
  },
};
</script>
<style>
/* .input{
  min-width:10px;
} */
.addContact {
  padding-right: 20px;
  font-size: 1.5em;
}
.deleteContact {
  font-size: 1.5em;
  float: right;
  color: red;
}
.prt {
  font-size: 1.2em;
}
</style>